export default {
  'Teklif Formu': 'Φόρμα Προσφοράς',
  'Kayıtlı Teklifler': 'Αποθηκευμένες Προσφορές',
  'Kullanıcı Adı': 'Όνομα Χρήστη',
  'Şifre': 'Κωδικός',
  'Giriş Yap': 'Σύνδεση',
  'Çıkış Yap': 'Αποσύνδεση',
  'KDV Oranı': 'Ποσοστό ΦΠΑ',
  'Teklif Durumu': 'Κατάσταση Προσφοράς',
  'Kaydet': 'Αποθήκευση',
  'PDF Önizleme': 'Προεπισκόπηση PDF',
  'PDF\'ye Aktar': 'Εξαγωγή σε PDF',
  'E-posta ile Gönder': 'Αποστολή με Email',
  'Alıcı': 'Παραλήπτης',
  'Tarih': 'Ημερομηνία',
  'Genel Toplam': 'Συνολικό Ποσό',
  'Not': 'Σημείωση',
  'KDV': 'ΦΠΑ',
  'Alt Toplam': 'Υποσύνολο',
  'Açıklama': 'Περιγραφή',
  'Ürün Adı': 'Όνομα Προϊόντος',
  'SUT Kodu': 'Κωδικός SUT',
  'Birim Alış Fiyatı': 'Τιμή Μονάδας',
  'Sipariş Adedi': 'Ποσότητα Παραγγελίας',
  'Promosyon Ürün': 'Προϊόν Προώθησης',
  'Toplam Adet': 'Συνολική Ποσότητα',
  'Sipariş Tutarı': 'Ποσό Παραγγελίας',
  'Durum': 'Κατάσταση',
  'Kabul Edildi': 'Αποδεκτό',
  'Reddedildi': 'Απορριφθέν',
  'Gönderildi': 'Αποσταλέν',
  'Taslak': 'Πρόχειρο',
  'Yurtiçi': 'Εγχώριο',
  'Yurtdışı': 'Διεθνές',
  'Sipariş Oluştur': 'Δημιουργία Παραγγελίας',
  'Ürün Sıralaması': 'Ταξινόμηση Προϊόντων',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': 'Τα προϊόντα ταξινομούνται κατά δημοτικότητα και σημασία',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': 'Τα προϊόντα καρδιολογίας και αγγειοχειρουργικής εμφανίζονται ως προτεραιότητα',
  'Ürün adı, açıklama veya barkod ile ara...': 'Αναζήτηση με όνομα προϊόντος, περιγραφή ή γραμμωτό κώδικα...',
  'Tüm Kategoriler': 'Όλες οι Κατηγορίες',
  'Kutu görünüm': 'Προβολή πλέγματος',
  'Liste görünüm': 'Προβολή λίστας',
  'Aradığınız kriterlere uygun ürün bulunamadı': 'Δεν βρέθηκαν προϊόντα που να αντιστοιχούν στα κριτήριά σας',
  'Ürün Adı Yok': 'Χωρίς Όνομα Προϊόντος',
  'Kategori Yok': 'Χωρίς Κατηγορία',
  'Açıklama yok': 'Χωρίς περιγραφή',
  'Firma Bilgilerini Doldurun': 'Συμπληρώστε Πληροφορίες Εταιρείας',
  'Sepete Ekle': 'Προσθήκη στο Καλάθι',
  'Firma Bilgileri': 'Πληροφορίες Εταιρείας',
  'Ülke Seçimi': 'Επιλογή Χώρας',
  'Türkiye': 'Τουρκία',
  'Almanya': 'Γερμανία',
  'ABD': 'ΗΠΑ',
  'Firma Ünvanı': 'Όνομα Εταιρείας',
  'Vergi Dairesi': 'ΔΟΥ',
  'Vergi Numarası': 'ΑΦΜ',
  'Adres': 'Διεύθυνση',
  'Şehir': 'Πόλη',
  'Yetkili': 'Εξουσιοδοτημένο Πρόσωπο',
  'Telefon': 'Τηλέφωνο',
  'Email': 'Email',
  'Bilgileri İlet': 'Αποστολή Πληροφοριών',
  'Lütfen eksik alanları doldurun': 'Παρακαλώ συμπληρώστε τα κενά πεδία',
  'Firma kaydedilemedi': 'Η εταιρεία δεν αποθηκεύθηκε',
  'Firma bilgileri başarıyla iletildi': 'Οι πληροφορίες εταιρείας αποστάλθηκαν επιτυχώς',
  'Firma Ünvanı:': 'Όνομα Εταιρείας:',
  'Yetkili Kişi:': 'Εξουσιοδοτημένο Πρόσωπο:',
  'Sepetiniz': 'Το Καλάθι Σας',
  'Sepetiniz boş': 'Το καλάθι σας είναι άδειο',
  'adet': 'τεμ',
  'Düzenle': 'Επεξεργασία',
  'Kaldır': 'Αφαίρεση',
  'Siparişi Tamamla': 'Ολοκλήρωση Παραγγελίας',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'Παρακαλώ πρώτα στείλτε τις πλήρεις πληροφορίες εταιρείας σας',
  'Sipariş başarıyla kaydedildi': 'Η παραγγελία αποθηκεύθηκε επιτυχώς',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'Μήνυμα καλωσορίσματος και σύνδεσμος πρόσβασης αποστάλθηκαν στο email σας',
  'Link 3 gün geçerlidir': 'Ο σύνδεσμος ισχύει για 3 ημέρες',
  'Sipariş kaydedilemedi': 'Η παραγγελία δεν αποθηκεύθηκε',
  'Firma Bilgileri Gerekli': 'Απαιτούνται Πληροφορίες Εταιρείας',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'Συμπληρώστε πρώτα τις πληροφορίες εταιρείας για προσθήκη στο καλάθι',
  'Önce Bilgileri Doldurun': 'Συμπληρώστε Πρώτα τις Πληροφορίες',
  'Uyarı': 'Προειδοποίηση',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'Πρέπει πρώτα να συμπληρώσετε τις πληροφορίες εταιρείας για προσθήκη στο καλάθι',
  'SUT Kütüphanesi Tanımı': 'Ορισμός Βιβλιοθήκης SUT',
  'SUT Kodu:': 'Κωδικός SUT:',
  'Standart': 'Πρότυπο',
  'Açıklama (isteğe bağlı)': 'Περιγραφή (προαιρετικό)',
  'Partner Ol': 'Γίνετε Συνεργάτης',
  'Partner başvuru popup açılacak': 'Θα ανοίξει το popup αίτησης συνεργάτη',
  'Dil': 'Γλώσσα',
  'E-posta': 'Email',
  'Şifre': 'Κωδικός',
  'Şifremi Unuttum': 'Ξέχασα τον Κωδικό',
  'Giriş yapılıyor...': 'Σύνδεση σε εξέλιξη...',
  'E-posta veya şifre hatalı': 'Λάθος email ή κωδικός',
  'Şifre sıfırlama e-postası gönderildi': 'Email επαναφοράς κωδικού αποστάλθηκε',
  'E-posta gönderilemedi': 'Το email δεν αποστάλθηκε',
  'Üye Ol': 'Εγγραφή',
  'Üye Değil Misiniz?': 'Δεν είστε μέλος;',
  'Şimdi Üye Ol': 'Εγγραφείτε Τώρα',
  'Misafir Kullanıcı': 'Επισκέπτης Χρήστης',
  'Hızlı Sipariş': 'Γρήγορη Παραγγελία',
  'Misafir Olarak Sipariş Verin': 'Παραγγείλετε ως Επισκέπτης',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'Επιλέξτε γρήγορα τα προϊόντα σας και δημιουργήστε την παραγγελία σας χωρίς σύνδεση',
  'Giriş yapmadan sipariş oluşturun': 'Δημιουργήστε παραγγελία χωρίς σύνδεση',
  'Anında Erişim': 'Άμεση Πρόσβαση',
  'Tüm ürünlere anında erişim': 'Άμεση πρόσβαση σε όλα τα προϊόντα',
  'Güvenli İşlem': 'Ασφαλής Συναλλαγή',
  'SSL korumalı güvenli sipariş': 'Ασφαλής παραγγελία προστατευμένη με SSL',
  'Misafir Olarak Sipariş Oluştur': 'Δημιουργήστε Παραγγελία ως Επισκέπτης',
  'İpucu:': 'Συμβουλή:',
  'Daha fazla özellik için üye olun': 'Εγγραφείτε για περισσότερες λειτουργίες',
  'Ücretsiz': 'Δωρεάν',
  'Hızlı': 'Γρήγορο',
  'Güvenli': 'Ασφαλές',
  'bayilikSozlesme': 'Διάβασα και αποδέχομαι τους όρους και προϋποθέσεις συνεργασίας INVAMED.',
  'geri': 'Πίσω',
  'basvuruGonder': 'Αποστολή Αίτησης',
  'ileri': 'Επόμενο',
  'sozlesmeGonderildi': 'Η Συνθήκη Αποστάλθηκε στο Email Σας!',
  'sozlesmeDesc': 'Παρακαλώ ανεβάστε τη Συνθήκη Συνεργασίας INVAMED και τα απαραίτητα έγγραφα που αποστάλθηκαν στο email σας παρακάτω.',
  'tamamla': 'Ολοκλήρωση Αίτησης',
  'basvuruAlindi': 'Η Αίτησή Σας Έχει Ληφθεί!',
  'basvuruAlindiDesc': 'Η ομάδα INVAMED θα εξετάσει την αίτησή σας και θα επικοινωνήσει μαζί σας το συντομότερο δυνατό.',
  'Başvuru Durumu': 'Κατάσταση αίτησης',
  'Başvurunuz onay sürecindedir': 'Η αίτησή σας εξετάζεται',
  'sifreSifirla': 'Επαναφορά Κωδικού',
  'sifreSifirlaDesc': 'Εισάγετε το εγγεγραμμένο email σας και θα σας στείλουμε οδηγίες επαναφοράς κωδικού.',
  'gonder': 'Αποστολή',
  'talimatGonderildi': 'Οι Οδηγίες Αποστάλθηκαν',
  'sentDesc': 'Οι οδηγίες επαναφοράς κωδικού αποστάλθηκαν στο <b>{email}</b>. Παρακαλώ ελέγξτε το email σας.',
  'helpTitle': 'Πώς μπορώ να συνδεθώ;',
  'helpList': [
    'Για να συνδεθείτε στον πίνακα διανομέα INVAMED, εισάγετε το εγγεγραμμένο email και κωδικό σας.',
    'Για σύνδεση με χρήστη demo:',
    'Αν ξεχάσατε τον κωδικό σας, χρησιμοποιήστε τον σύνδεσμο "Ξέχασα τον Κωδικό" για να ζητήσετε επαναφορά.',
    'Αν έχετε προβλήματα σύνδεσης, βεβαιωθείτε ότι το email και ο κωδικός σας είναι σωστά. Αν το πρόβλημα συνεχίζεται, επικοινωνήστε με την ομάδα υποστήριξής μας.'
  ],
  'partnerlikSozlesmeTitle': 'Συνθήκη Συνεργασίας INVAMED και Όροι',
  'partnerlikSozlesmeText': `1. ΓΕΝΙΚΕΣ ΔΙΑΤΑΞΕΙΣ

Η παρούσα συνθήκη συνάπτεται μεταξύ INVAMED (από εδώ και στο εξής "Εταιρεία") και του υποψήφιου συνεργάτη (από εδώ και στο εξής "Συνεργάτης") για σκοπούς συνεργασίας στην πώληση ιατρικών συσκευών και εξοπλισμού.

2. ΣΥΝΘΗΚΕΣ ΣΥΝΕΡΓΑΣΙΑΣ

2.1. Ο Συνεργάτης πρέπει να έχει νομική εξουσία για την πώληση ιατρικών συσκευών.
2.2. Ο Συνεργάτης πρέπει να είναι οργανισμός που λειτουργεί στον τομέα της υγειονομικής περίθαλψης.
2.3. Ο Συνεργάτης πρέπει να έχει τις απαραίτητες άδειες και πιστοποιήσεις.
2.4. Ο Συνεργάτης πρέπει να είναι οικονομικά αξιόπιστος.

3. ΥΠΟΧΡΕΩΣΕΙΣ ΤΩΝ ΜΕΡΩΝ

Υποχρεώσεις της Εταιρείας:
3.1. Παροχή ποιοτικών προϊόντων και υπηρεσιών
3.2. Παροχή τεχνικής υποστήριξης
3.3. Παροχή εκπαίδευσης και πληροφοριών
3.4. Διαφάνεια στην τιμολόγηση

Υποχρεώσεις του Συνεργάτη:
3.1. Αποθήκευση προϊόντων σε κατάλληλες συνθήκες
3.2. Παροχή ποιοτικής εξυπηρέτησης πελατών
3.3. Συμμόρφωση με νομικούς κανονισμούς
3.4. Προστασία της εμπορικής μάρκας της εταιρείας

4. ΤΙΜΟΛΟΓΗΣΗ ΚΑΙ ΠΛΗΡΩΜΗ

4.1. Οι τιμές καθορίζονται από την Εταιρεία
4.2. Ο Συνεργάτης υποχρεούται να διατηρεί τις καθορισμένες τιμές
4.3. Οι όροι πληρωμής καθορίζονται ξεχωριστά
4.4. Οι προμήθειες μπορεί να ποικίλλουν ανάλογα με την απόδοση

5. ΕΜΠΙΣΤΟΣΥΝΗ ΚΑΙ ΑΣΦΑΛΕΙΑ

5.1. Τα μέρη υποχρεούνται να προστατεύουν τις εμπιστευτικές πληροφορίες του άλλου
5.2. Οι πληροφορίες πελατών πρέπει να διατηρούνται εμπιστευτικές
5.3. Πρέπει να τηρούνται τα πρότυπα ασφαλείας δεδομένων

6. ΔΙΑΡΚΕΙΑ ΚΑΙ ΛΥΣΗ ΤΗΣ ΣΥΝΘΗΚΗΣ

6.1. Η παρούσα συνθήκη ισχύει για 1 έτος
6.2. Μπορεί να παραταθεί με αμοιβαία συμφωνία
6.3. Μπορεί να λυθεί με προειδοποίηση 30 ημερών
6.4. Μπορεί να λυθεί άμεσα σε περίπτωση σοβαρής παραβίασης

7. ΕΠΙΛΥΣΗ ΔΙΑΦΟΡΩΝ

7.1. Οι διαφορές προσπαθούν να επιλυθούν πρωτίστως μέσω διαπραγμάτευσης
7.2. Τα δικαστήρια της Δημοκρατίας της Τουρκίας είναι αρμόδια για μη επιλυμένες περιπτώσεις

8. ΙΣΧΥΣ

Η παρούσα συνθήκη έχει διαβαστεί, κατανοηθεί και αποδεχθεί από τα μέρη.`,
  'partnerlikSozlesmeOnay': 'Διάβασα, κατάλαβα και αποδέχομαι τη Συνθήκη Συνεργασίας INVAMED και τους Όρους παραπάνω. Δηλώνω ότι αποδέχομαι όλα τα άρθρα αυτής της συνθήκης και θα εκπληρώσω τις υποχρεώσεις μου.',
  'sozlesmeyiGoruntule': 'Προβολή Συνθήκης',
  'sozlesmeyiKapat': 'Κλείσιμο',
  'Ürün': 'Προϊόν',
  'Ürün eklemek için ürün listesinden seçim yapın': 'Επιλέξτε από τη λίστα προϊόντων για προσθήκη στο καλάθι',
  'Etiketler': 'Ετικέτες',
  'Öncelikli': 'Προτεραιότητα',
  'Kapat': 'Κλείσιμο',
  'globalPartnersTitle': 'Συνεργασία με 30,000 Συνεργάτες σε Όλο τον Κόσμο',
  'globalPartnersDesc': 'Η εκτεταμένη παγκόσμια δίκτυό μας 30,000 συνεργατών προωθεί την κοινή καινοτομία, την ανταλλαγή γνώσεων και την αμοιβαία επιτυχία. Εργαζόμενοι μαζί, επεκτείνουμε συνεχώς τα όρια της φροντίδας ασθενών.',
  'Yardım': 'Βοήθεια',
  'dil': 'Γλώσσα',
  'Connect Free!': 'Συνδεθείτε δωρεάν!',
  'En çok tercih edilen ürünlerimizi keşfedin': 'Ανακαλύψτε τα πιο δημοφιλή προϊόντα μας',
  'Tüm Kategoriler': 'Όλες οι κατηγορίες',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48 προϊόντα εμφανίζονται (Σύνολο: 8000+)',
  'Tüm Ürünleri Gör →': 'Δείτε όλα τα προϊόντα →',
  'Detaylar': 'Λεπτομέρειες',
  'Sipariş Ver': 'Παραγγείλετε τώρα',
  'Giriş Yap': 'Σύνδεση',
  'Hesabınıza giriş yapın': 'Συνδεθείτε στον λογαριασμό σας',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'Αυτός ο ιστότοπος προστατεύεται από το reCAPTCHA και ισχύουν η Πολιτική Απορρήτου και οι Όροι Υπηρεσίας της Google.',
  'Ürün Kataloğumuz': 'Ο κατάλογος προϊόντων μας',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': 'Προσφέρουμε πάνω από 8000 προϊόντα',
  '1,3B': '1,3K',
  'Partner': 'Συνεργάτης',
  '8,4M': '8,4M',
  'Toplam Üretim': 'Συνολική παραγωγή',
  '23': '23',
  'Branş': 'Υποκατάστημα',
  '27,5B': '27,5K',
  'Toplam Sipariş': 'Συνολικές παραγγελίες',
  'Connect Now': 'Συνδεθείτε τώρα',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'Εγγραφείτε δωρεάν για να αποκτήσετε πρόσβαση σε όλες τις πληροφορίες σε ένα μέρος.',
  'Ürün Detayları': 'Λεπτομέρειες προϊόντος',
  'Kapat': 'Κλείσιμο',
  'Yükleniyor...': 'Φόρτωση...',
  'Hata': 'Σφάλμα',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}} προϊόντα εμφανίζονται (Σύνολο: 8000+)',
  'Şehir Seçimi': 'Επιλογή Πόλης',
  'Firma / Sağlık Profesyoneli': 'Εταιρεία / Επαγγελματίας Υγείας',
  'Yetkili Kişi': 'Εξουσιοδοτημένο Πρόσωπο',
  'Telefon': 'Τηλέφωνο',
  'E-posta': 'Email',
  'Temel Bilgiler': 'Βασικές Πληροφορίες',
  'Ek Bilgiler': 'Πρόσθετες Πληροφορίες',
  'Faaliyet Alanı / Sektör': 'Τομέας Δραστηριότητας / Τομέας',
  'Ülke Seçimi': 'Επιλογή Χώρας',
  'Ülke adı veya kodu ara...': 'Αναζήτηση ονόματος ή κωδικού χώρας...',
  'region.Avrupa': 'Ευρώπη',
  'region.Amerika': 'Αμερική',
  'region.Asya': 'Ασία',
  'region.Afrika': 'Αφρική',
  'region.Okyanusya': 'Ωκεανία',
  'region.Diğer': 'Άλλο',
  'country.TR': 'Τουρκία',
  'country.US': 'Ηνωμένες Πολιτείες',
  'country.DE': 'Γερμανία',
  'country.FR': 'Γαλλία',
  'country.GB': 'Ηνωμένο Βασίλειο',
  'country.IT': 'Ιταλία',
  'country.ES': 'Ισπανία',
  'country.RU': 'Ρωσία',
  'country.CN': 'Κίνα',
  'country.JP': 'Ιαπωνία',
  'country.KR': 'Νότια Κορέα',
  'country.IN': 'Ινδία',
  'country.BR': 'Βραζιλία',
  'country.CA': 'Καναδάς',
  'country.AU': 'Αυστραλία',
  'Ticaret Sicil No': 'Αριθμός Εμπορικού Μητρώου',
};
